import React from 'react';

function LoadingScreen() {
  return (
    <div className="loading-screen" role="status" aria-live="polite" aria-label="Loading Mbhetech Solutions">
      <div className="loading-screen__glow" />
      <div className="loading-screen__content">
        <img className="loading-screen__logo" src="/mbhetech.png" alt="Mbhetech Solutions logo" />
        <p className="loading-screen__label">Welcome to</p>
        <h1 className="loading-screen__title">Mbhetech Solutions</h1>
        <div className="loading-screen__bar" />
      </div>
    </div>
  );
}

export default LoadingScreen;
